import { Component, Directive, ElementRef, HostListener, Input, OnInit, Renderer2 } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-filterable-list',
  templateUrl: './filterable-list.component.html'
})


export class FilterableListComponent implements OnInit {

  public searchItem: UntypedFormGroup;
  public showList = false;
  public selected = 0;

  private _selectedItem: UntypedFormGroup;

  get selectedItem(): UntypedFormGroup { return this._selectedItem; }
  @Input() set selectedItem(item: UntypedFormGroup) {
    this._selectedItem = item;
    if (this._selectedItem && this._selectedItem.value) {
      this.searchItem.get('des').patchValue(this._selectedItem.value.des);
    }
    this.searchItem.get('des').setValidators(item.validator);
    this.searchItem.updateValueAndValidity();

    if (this._selectedItem.disabled) {
      this.searchItem.disable();
    } else {
      this.searchItem.enable();
    }
  }
  @Input() itemsList: Array<any>;
  @Input() disabled: Subject<boolean>;
  @Input() placeHolder: boolean;

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.showList = false;
      if (this.selectedItem && this.selectedItem.value) {
        this.searchItem.get('des').patchValue(this.selectedItem.value.des);
      } else {
        this.searchItem.reset();
      }
    }
  }

  constructor(private _fb: UntypedFormBuilder, private eRef: ElementRef, private renderer: Renderer2) {
    this.searchItem = this._fb.group({
      id: [''],
      des: ['']
    });
  }

  ngOnInit() {
    this._selectedItem.valueChanges.subscribe(() => {
      if (this._selectedItem && this._selectedItem.value) {
        this.searchItem.patchValue(this._selectedItem.value);
      } else {
        this.searchItem.reset();
      }

      if (this._selectedItem && this._selectedItem.validator) {
        this.searchItem.get('des').setValidators(this._selectedItem.validator);
        this.searchItem.updateValueAndValidity();
      }

    });

    this.searchItem.valueChanges.subscribe(() => {
      if (this.filteredList && this.filteredList.length === 1) {
        this.selected = 0;
      }
    });


    if (this.disabled) {
      this.disabled.subscribe(disable => {
        if (disable) {
          this.searchItem.disable();
        } else {
          this.searchItem.enable();
        }
      });
    }
  }

  public reset(event) {
    this.searchItem.reset();
    this.selectedItem.reset();
    this.showList = false;
    event.stopPropagation();
  }

  public selectItem(item) {
    this.searchItem.reset();
    this.selectedItem.reset();
    this.searchItem.patchValue(item);
    this.selectedItem.patchValue(item);
    this.showList = false;
  }

  public selectItemEnter() {
    this.searchItem.patchValue(this.filteredList[this.selected]);
    // this.searchItem.reset();
    // this.selectedItem.reset();
    this.selectedItem.patchValue(this.filteredList[this.selected]);
    this.showList = false;
  }

  public get filteredList() {
    if (this.itemsList) {
      // if (Object.getOwnPropertyNames(this.itemsList[0]).sort().toString().includes('anyo')) {
      //   console.log(Object.getOwnPropertyNames(this.itemsList[0]).sort().toString());
      //   this.itemsList.forEach(item => {
      //     item.des = item.anyo.toString();
      //   });
      // }
      if (this._selectedItem && this._selectedItem.value) {
        let list = this.itemsList;
        if (this.searchItem.get('des').value !== this._selectedItem.value.des) {
          list = this.itemsList.filter(x => x.des.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().includes(
            this.searchItem.get('des').value ? this.searchItem.get('des').value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase() : ''));
        }
        return list;
      } else {
        return this.itemsList.filter(x => x.des.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().includes(
          this.searchItem.get('des').value ? this.searchItem.get('des').value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase() : ''));
      }
    }
  }

  public removeAccents(value) {
    return value
      .replace(/á/g, 'a')
      .replace(/é/g, 'e')
      .replace(/í/g, 'i')
      .replace(/ó/g, 'o')
      .replace(/ú/g, 'u').toUpperCase();

  }

  public setDisable(disable) {
    if (disable) {
      this.searchItem.disable();
    } else {
      this.searchItem.enable();
    }
  }

  public select(up) {
    if (this.filteredList.length > 1) {
      if (up) {
        if (this.selected > 0) {
          this.selected--;
          const slides = document.getElementById('item' + this.selected);
          if (slides) {
            slides.scrollIntoView({ block: 'nearest', inline: 'start' });
          }
        }
      } else {
        if (this.selected < (this.filteredList.length - 1)) {
          this.selected++;
          const slides = document.getElementById('item' + this.selected);
          if (slides) {
            slides.scrollIntoView({ block: 'nearest', inline: 'start' });
          }
        }
      }
    } else {
      this.selected = this.itemsList.indexOf(this.itemsList.find(x => x.id === this._selectedItem.value.id));
    }
  }

  public getPlaceholder() {
    let placeholder = '';

    if (this.placeHolder && this.itemsList && this.itemsList !== null) {
      if (this.itemsList.length > 1) {
        placeholder = this.itemsList[0].des + ',' + ' ' + this.itemsList[1].des + '...';
      } else {
        placeholder = this.itemsList[0] ? this.itemsList[0].des : ' ';
      }
    }
    return placeholder;
  }

  public startComponent() {
    this.showList = !this.showList;
    if (this.filteredList.length === 1) {
      this.selected = this.itemsList.indexOf(this.itemsList[0]);
    } else if (this._selectedItem && this._selectedItem.value) {
      this.selected = this.itemsList.indexOf(this.itemsList.find(x => x.id === this._selectedItem.value.id));
    } else {
      this.selected = 0;
    }
  }

}
